import Why from "@/components/service/Why";
import Features from "@/components/service/Features";
import MetaTags from "@/components/MetaTags";
import emailContent from "@/constants/content/email";
import emailPricing from "@/constants/pricing/email";
import Pricing from "@/components/pricing";
import Hero from "./_components/hero";
import {
  FaEnvelope,
  FaBullseye,
  FaPaintBrush,
  FaChartLine,
  FaUser,
  FaRegChartBar,
} from "react-icons/fa";
import HowItWorks from "./_components/how-it-works";
import whyImage from "@/public/services/img4.png";

const EmailMarketing = () => {
  const reasons = [
    {
      title: "Automated Flows",
      description: (
        <>
          <mark>
            Recover up to <strong>40%</strong> of lapsed visitors
          </mark>{" "}
          through behaviour‑triggered reminders
        </>
      ),
      icon: <FaEnvelope />,
    },
    {
      title: "Segmented Campaigns",
      description: (
        <>
          <mark>
            Boost opens by up to <strong>105%</strong>
          </mark>{" "}
          with laser‑focused segmentation
        </>
      ),
      icon: <FaBullseye />,
    },
    {
      title: "Branded Templates & Pop‑Ups",
      description: (
        <>
          <mark>
            Grow your list by up to <strong>120%</strong>
          </mark>{" "}
          in just six months
        </>
      ),
      icon: <FaPaintBrush />,
    },
    {
      title: "Data‑Driven Optimization",
      description:
        "Continuous A/B testing on subject lines and send times to elevate performance",
      icon: <FaChartLine />,
    },
    {
      title: "Personalized Content",
      description: "Enhance engagement with tailored messaging for each user",
      icon: <FaUser />,
    },
    {
      title: "Real-time Analytics",
      description:
        "Optimize campaigns instantly with live performance insights",
      icon: <FaRegChartBar />,
    },
  ];

  return (
    <>
      <MetaTags
        pageTitle={emailContent.title}
        pageDescription={emailContent.content.hero.description}
        path={`/${emailContent.path}`}
        isHome={false}
      />
      <Hero />

      <section className="relative mx-auto flex max-w-screen-xl flex-col items-center px-5">
        <h2 className="mb-5 pt-4 text-center text-3xl font-bold tracking-tight lg:text-left lg:text-4xl">
          Why Clients See Up to <mark>26 % More Revenue</mark> From Our Emails &
          SMS
        </h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-0">
          {reasons.map((reason) => {
            return (
              <div className="lg:p-8" key={reason.title}>
                <div className="mb-3 flex justify-center text-4xl text-vblue3 hue-rotate-[30deg]">
                  {reason.icon}
                </div>
                <div>
                  <h3 className="mb-1 text-center text-lg font-bold">
                    {reason.title}
                  </h3>
                  <p className="text-center">{reason.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <HowItWorks />
      <Why
        title={emailContent.content.why.title}
        subtitle={emailContent.content.why.subtitle}
        description={emailContent.content.why.description}
        description2={emailContent.content.why.description2}
        descriptionLink={emailContent.content.why.descriptionLink}
        image={emailContent.content.why.image}
        list={emailContent.content.why.list}
      />
      <Why
        title="Why SMS Marketing?"
        subtitle="Reach the Right Customer at the Perfect Moment "
        description="Why stop at the inbox? Reach customers in real time with on-brand texts that cut through the noise and convert in seconds. From welcome coupons to back-in-stock alerts to custom crafted SMS campaigns, Ventura can design, automate, and optimize every message your buyers actually want to read. Add SMS to your existing email strategy today."
        image={whyImage}
        reverse
      />
      <Features
        title={emailContent.content.features.title}
        subtitle={emailContent.content.features.subtitle}
        description={emailContent.content.features.description}
        list={emailContent.content.features.list}
      />
      <Pricing data={emailPricing} />
    </>
  );
};

export default EmailMarketing;
